// src/stores/system.store.ts
import { create } from 'zustand'

type SystemState = {
  backendDown: boolean
  backendDownReason?: string
  setBackendDown: (reason?: string) => void
  setBackendUp: () => void
}

export const useSystemStore = create<SystemState>(set => ({
  backendDown: false,
  backendDownReason: undefined,
  setBackendDown: reason => set({ backendDown: true, backendDownReason: reason }),
  setBackendUp: () => set({ backendDown: false, backendDownReason: undefined }),
}))
